export default __webpack_public_path__ + "static/media/Ellipse14.06a49422.svg";